import api from 'api'
import {
  IEvaluationResume,
  IEvaluationSection,
  IQuestion,
} from 'models/evaluation.model'
import { EvaluationResponseStatus } from 'enum/evaluationResponseStatus.enum'

const getEvaluation = (id: number) =>
  api.get<IEvaluationResume>(`/evaluations/${id}`).then((res) => res.data)

const createEvaluationResponse = (evaluationId: number) =>
  api
    .post<{
      data: {
        attributes: {
          id: number
          attempt: number
          status: EvaluationResponseStatus
          total_score: null | number
          correct: null | number
          approved: null | boolean
          active: boolean
          created_at: string
          updated_at: string
        }
      }
    }>(`/evaluation_responses`, { evaluationId })
    .then((res) => res.data)

const getEvaluationSections = (id: number, options?: { review?: boolean }) =>
  api
    .get<IEvaluationSection[]>(`/evaluations/${id}/sections`, {
      params: { review: options?.review },
    })
    .then((res) => res.data)

const saveUserAnswer = (
  id: number,
  questionId: number,
  userAnswer: IQuestion['userAnswer']
) =>
  api.put(`/evaluation_responses/${id}/questions/${questionId}`, {
    answer: userAnswer?.response,
  })

const startEvaluation = (id: number) =>
  api.post(`/evaluation_responses/${id}/start`)

const finishEvaluation = (id: number) =>
  api.post(`/evaluation_responses/${id}/complete`)

const resetEvaluationResponse = (
  evaluationResponseId: number,
  manager = false,
  autoReset = false
) =>
  api.post(
    `/administration/evaluations/results/${evaluationResponseId}/reset`,
    { manager, auto_start: autoReset }
  )

export const evaluationsService = {
  getEvaluation,
  getEvaluationSections,
  saveUserAnswer,
  createEvaluationResponse,
  finishEvaluation,
  startEvaluation,
  resetEvaluationResponse,
}
